const header = {
	state:    {
		scrollTriggers: [],
	},
	elements: {
		$header:   $('header'),
		$sections: $('[data-header-theme]'),
	},

	init() {
		this.initEvents()

		window.addEventListener('resize', () => {
			this.initEvents()
		})
	},

	initEvents() {
		this.state.scrollTriggers.forEach((trigger) => trigger.kill())
		this.state.scrollTriggers = []
		this.elements.$header.attr('theme', 'light')

		const getTriggerPosition = (triggerValue) => {
			const vhValue = parseInt(triggerValue?.split('vh')[0])

			if (vhValue) {
				return `+=${window.innerHeight * vhValue / 100}`
			}

			return triggerValue
		}

		if (window.innerWidth >= 768) {
			this.elements.$sections.each((i, section) => {
				this.state.scrollTriggers.push(window.ScrollTrigger.create({
					trigger:     section,
					start:       getTriggerPosition($(section).attr('data-header-theme-start')) || 'top 32px',
					end:         getTriggerPosition($(section).attr('data-header-theme-end')) || 'bottom 32px',
					onEnter:     () => {
						this.elements.$header.attr('theme', $(section).attr('data-header-theme') ?? $(section).attr('theme') ?? 'light')
					},
					onLeave:     () => {
						if ($(section).attr('data-header-theme-leave')) {
							this.elements.$header.attr('theme', $(section).attr('data-header-theme-leave') ?? $(section).attr('theme') ?? 'light')
						}
					},
					onEnterBack: () => {
						this.elements.$header.attr('theme', $(section).attr('data-header-theme') ?? $(section).attr('theme') ?? 'light')
					},
					onLeaveBack: () => {
						if ($(section).attr('data-header-theme-leave-back')) {
							this.elements.$header.attr('theme', $(section).attr('data-header-theme-leave-back') ?? $(section).attr('theme') ?? 'light')
						}
					},
				}))
			})
		}
	},
}

export default header
